import { EventType, PublicClientApplication, type AuthenticationResult } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./msalConfig";

/**
 * Eén instantie voor de hele app, zodat overal hetzelfde Microsoft-account
 * en dezelfde token-cache gebruikt worden.
 */
export const msalInstance = new PublicClientApplication(msalConfig);

/** Wacht hierop vóór een token-aanvraag (officiële MSAL-initialisatie). */
export const msalInitPromise = msalInstance.initialize();

msalInstance.addEventCallback((event) => {
  if (
    event.eventType !== EventType.LOGIN_SUCCESS &&
    event.eventType !== EventType.ACQUIRE_TOKEN_SUCCESS
  ) {
    return;
  }
  const account = (event.payload as AuthenticationResult | null)?.account;
  if (account) {
    msalInstance.setActiveAccount(account);
  }
});

void msalInitPromise.then(() => {
  const existing = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  if (existing) {
    msalInstance.setActiveAccount(existing);
  }
  // Oude losse kopie. Het token komt nu rechtstreeks uit de MSAL-cache.
  localStorage.removeItem("access_token");
});

export { loginRequest };
